module.exports = __webpack_public_path__ + "static/media/Source Info.2c150791.txt";